/**
 * Set ad source cookie based on URL parameters
 */
function setAdSourceCookie() {
    const currentUri = window.location.href;

    let adSource = null;

    if (currentUri.includes('gclid')) {
        adSource = 'google-ads';
    }
    else if (currentUri.includes('msclkid')) {
        adSource = 'bing';
    }

    if (adSource) {
        // add session cookie with ad source
        document.cookie = `ad_source=${adSource}; Secure; SameSite=Strict; Path=/;`;
    }
}

/**
 * Initialize ad source cookie
 */
export function initAdSource() {
    window.addEventListener('CookiebotOnAccept', function (e) {
        if (window.Cookiebot && window.Cookiebot.consent.marketing) {
            setAdSourceCookie();
        }
    }, {once: true, passive: true});

    if (window.Cookiebot && window.Cookiebot.consent.marketing) {
        setAdSourceCookie();
    }
}
